// extracted by mini-css-extract-plugin
module.exports = {"progress":"Slider__progress__2XqST","knob":"Slider__knob__axLVG","progressTrack":"Slider__progressTrack__1DhzK","progressBar":"Slider__progressBar__3JyOz"};